import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Form,
  Input,
  Label,
  Button,
  UncontrolledTooltip,
  Modal,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal"
import PeriodBtn from '../../components/Filter/PeriodBtn';
import ContactsDetails from '../Contacts/ViewDetail';
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import classnames from "classnames"
import Select from "react-select";

import {
  setContacsResult as onSetContacsResult,
  setUploadContactsOpen as onSetUploadContactsOpen,
  getContactsList as onGetContactsList,
  changeContactsList as onChangeContactsList,
  multipleStarContacts as onMultipleStarContacts,
  multipleUnstarContacts as onMultipleUnstarContacts,
  multipleHideContacts as onMultipleHideContacts,
  multipleUnhideContacts as onMultipleUnhideContacts,
  multipleUnsubscribeContacts as onMultipleUnsubscribeContacts,
  saveContacts as onSaveContacts,
  deleteContacts as onDeleteContacts,
  saveContactsSettings as onSaveContactsSettings,
  getContactsSettings as onGetContactsSettings,
  downContactsExcel as onDownContactsExcel,
  setSearchSettings as onSetSearchSettings,
  setContactsLoading as onSetContactsLoading,

  getUploadedContactsList as onGetUploadedContactsList,
  saveUploadedContacts as onSaveUploadedContacts,
  deleteUploadedContacts as onDeleteUploadedContacts,
  deleteUploadedContactsByFile as onDeleteUploadedContactsByFile,
  downUploadedContactsExcel as onDownUploadedContactsExcel,
  changeUploadedContactsList as onChangeUploadedContactsList,

  checkEmailUnsubscribe as onCheckEmailUnsubscribe,
  changeCheckUnsubsEmailAddressFlag as onChangeCheckUnsubsEmailAddressFlag,
  setSuccess as onSetSuccess,

  getContactSearchList as onGetContactSearchList,
  changeContactSearchList as onChangeContactSearchList,
  downSearchEntityExcel,
  disableContactSendYn,
  enableContactSendYn,
  getAllCountryList as onGetAllCountryList,
} from "../../store/actions";
import { cloneDeep } from 'lodash';
import UploadContactsModal from './UploadContactsModal';
import dateFormat from 'dateformat';
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import SelectCountry from '../../components/Filter/SelectCountry';
import ManageContacts from './ManageContacts';
import SearchEntity from './SearchEntity';
import UploadedContacts from './UploadedContacts';

const Contacts = props => {
  const dispatch = useDispatch();

  const { noticeStr, noticeStrUp, mainList, searchSettings, loading, result, totalPage, isSearched, uploadedContactsList, uploadContactsHistory, totalPageUp, userGrade, uploadContactsOpen, unsubsEmailAddress1, unsubsEmailAddress2, checkUnsubsEmailAddressFlag, screenName, success, searchList, totalPageSearch, contactSearchLoading } = useSelector(state => ({
    noticeStr: state.Contacts.noticeStr,
    noticeStrUp: state.Contacts.noticeStrUp,
    mainList: state.Contacts.contactsList,
    searchSettings: state.Contacts.searchSettings,
    loading: state.Contacts.loading,
    result: state.Contacts.result,
    totalPage: state.Contacts.totalPage,
    isSearched: state.Contacts.isSearched,

    // searchSettingsUp: state.Contacts.searchSettingsUp,
    uploadedContactsList: state.Contacts.uploadedContactsList,
    uploadContactsHistory: state.Contacts.uploadContactsHistory,
    totalPageUp: state.Contacts.totalPageUp,
    userGrade: state.Contacts.userGrade,

    uploadContactsOpen: state.Contacts.uploadContactsOpen,

    unsubsEmailAddress1: state.Contacts.unsubsEmailAddress1,
    unsubsEmailAddress2: state.Contacts.unsubsEmailAddress2,
    checkUnsubsEmailAddressFlag: state.Contacts.checkUnsubsEmailAddressFlag,
    screenName: state.Contacts.screenName,

    success: state.FilerRankings.success,

    searchList: state.Contacts.searchList,
    totalPageSearch: state.Contacts.totalPageSearch,
    contactSearchLoading: state.Contacts.contactSearchLoading,
  }));

  const { countryList } = useSelector(state => ({
    countryList: state.GeneralStatistics.countryList,
  }));

  const [isOpen, setIsOpen] = useState(true);
  const [chkAllFlag, setChkAllFlag] = useState(false);
  const [hideOrUnhide, setHideOrUnhide] = useState("Hide");
  const [starOrUnstar, setStarOrUnstar] = useState("Star");
  const [confirmMsg, setConfirmMsg] = useState("");
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [curPageInput, setCurPageInput] = useState(1);
  const [curPageInputUp, setCurPageInputUp] = useState(1);
  const [activeTab, setActiveTab] = useState("Manage");
  const [curPageSearch, setCurPageSearch] = useState(1);
  const [chkAllFlag_Search, setChkAllFlag_Search] = useState(false);
  const [hideOrUnhide_Search, setHideOrUnhide_Search] = useState("Hide");
  const [starOrUnstar_Search, setStarOrUnstar_Search] = useState("Star");
  const [enableOrDisable, setEnableOrDisable] = useState("Disable");
  function toggleActiveTab(tab) {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  /**
   * errMsg[0] : .csv 파일이 아님
   * errMsg[1] : 선택된 entity 없음.
   * errMsg[2] : 선택된 contact 없음.
   * errMsg[3] : save되지 않은 contact 선택함.
   * errMsg[4] : 필수항목 미입력
   * errMsg[5] : email 형식 잘못됨
   * errMsg[6] : 필수항목 미입력
   */
  const errMsg = [
    "not csv file"
    , "Please select a entity."
    , "Please select a contact."
    , "There are unsaved rows."
    , "Email address is required."
    , <>Invalid email format: Please check if you accidentally included any special characters or blank spaces.
      <br /><br />Please refer to the following websites to check for any hidden special characters or blank spaces:
      <br /> <a href='https://www.regextester.com/99810' target='_blank'>https://www.regextester.com/99810</a>,
      <br /> <a href='https://freetools.textmagic.com/unicode-detector' target='_blank'>https://freetools.textmagic.com/unicode-detector</a>
      <br />*Please note that we do not have any affiliation with these websites, but we found them helpful.</>
    , "First name is required."
    , "This email address already exists for this entity!"
    , "The following email addresses have already been unsubscribed:"
    , <>If you selected All Entity status,<br />Please enter a Name of holder or representative or Domain</>
    , "You can save up to 3 contacts per entity."
    , "From date is required" // 11
    , "To date is required" // 12
    , "From date must be earlier than to date" // 13
    , "To date cannot be in the future" // 14
    , <>If you selected Only non-hidden Entity status,<br />Please enter a Name of holder or representative or Domain</>
    , "The following email addresses contain unsubscribed domains:" // 16
  ];

  const [dupeEmailAddress, setDupeEmailAddress] = useState([]);
  const [chkAllFlagUp, setChkAllFlagUp] = useState(false);

  useEffect(() => {
    if (isSearched) {
      // 새로고침
      filterValidation.setFieldValue("submitType", "view");
      filterValidation.handleSubmit(filterValidation.values);
    } else {
      //첫 액세스
      dispatch(onGetContactsSettings());
    }
  }, []);

  useEffect(() => {
    if (checkUnsubsEmailAddressFlag && screenName == 'List') {
      dispatch(onChangeCheckUnsubsEmailAddressFlag(false));
      filterValidation.setFieldValue("submitType", "Save");
      setConfirmMsg("Are you sure you want to save the selected email(s)?");
      setConfirmAlert(true);
    }
  }, [checkUnsubsEmailAddressFlag]);

  useEffect(() => {
    if (!uploadContactsOpen) {
      // console.log('imported email address 조회')
      // imported email address 조회 
      filterValidation.setFieldValue("submitType", "viewUp");
      filterValidation.handleSubmit(filterValidation.values);
    }
  }, [uploadContactsOpen]);

  const toggle = () => {
    setIsOpen(!isOpen);
  }

  const filterValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      submitType: "view",
      entityName: searchSettings && searchSettings.targetGroupName ? searchSettings.targetGroupName : "",
      entityWebDomain: searchSettings && searchSettings.domain ? searchSettings.domain : "",
      entityStatus: searchSettings && searchSettings.entityStatus ? searchSettings.entityStatus : "",
      contactEmail: searchSettings && searchSettings.emailAddress ? searchSettings.emailAddress : "",
      contactName: searchSettings && searchSettings.name ? searchSettings.name : "",
      contactTitle: searchSettings && searchSettings.title ? searchSettings.title : "",
      contactPosition: searchSettings && searchSettings.position ? searchSettings.position : "",
      contactCountry: searchSettings && searchSettings.country ? searchSettings.country : "",
      contactOffice: searchSettings && searchSettings.office ? searchSettings.office : "",
      contactStatus: searchSettings && searchSettings.unsubscribe ? searchSettings.unsubscribe : "",
      datePeriod: searchSettings && searchSettings.datePeriod ? searchSettings.datePeriod : "",
      fromDate: undefined,
      toDate: undefined,
      sortType: "NRD",
      perPage: 20,
      curPage: 1,

      emailAddress: "",
      firstName: "",
      lastName: "",
      title: "",
      position: "",
      country: "",
      office: "",
      // sortTypeUp: "NRD",
      perPageUp: 20,
      curPageUp: 1,

      entityStatusSearch: "",
      searchName: "",
      searchDomain: "",
      crCdList: [],
      searchAddress: "",
      perPageSearch: 20,
      curPageSearch: 1,

      importHisSortType: "IDD"
    },
    validationSchema: Yup.object().shape({
      /* fromDate: Yup.date()
       .when('toDate', (toDate, schema) => {
       return toDate
                     ? schema.max(toDate, "From date must be earlier than to date")
                     : schema;
       }),
         toDate: Yup.date()
           .max(new Date(), "Date cannot be in the future"),
         // .required("Please Select to date"), */
    }),
    validateOnChange: false, // this one
    validateOnBlur: false, // and this one
    onSubmit: (values) => {
      // console.log(JSON.stringify(values, null, 2));


      let submitType = values["submitType"];
      const today = new Date().setHours(0, 0, 0, 0);

      if (["view", "excel", "pdf", "saveSettings"].includes(submitType)) {
        // console.log("true")
        const startDate = new Date(values["fromDate"]).setHours(0, 0, 0, 0); // yyyy-mm-dd
        const endDate = new Date(values["toDate"]).setHours(0, 0, 0, 0);
        if (startDate && !values["toDate"]) {
          dispatch(onSetContacsResult(12)); return false;
        } else if (!values["fromDate"] && endDate) {
          dispatch(onSetContacsResult(11)); return false;
        } else if (endDate > today) {
          dispatch(onSetContacsResult(14)); return false;
        } else if (startDate > endDate) {
          dispatch(onSetContacsResult(13)); return false;
        }
      }

      const filterParam = {
        targetGroupName: values["entityName"],
        domain: values["entityWebDomain"],
        entityStatus: values["entityStatus"],
        emailAddress: values["contactEmail"],
        name: values["contactName"],
        title: values["contactTitle"],
        position: values["contactPosition"],
        country: values["contactCountry"],
        office: values["contactOffice"],
        unsubscribe: values["contactStatus"],
        startDate: values["fromDate"],
        endDate: values["toDate"],
        sortType: values["sortType"],
        perPage: values["perPage"],
        curPage: values["curPage"],
      };

      const filterParamSearch = {
        entityStatus: values["entityStatusSearch"],
        targetGroupName: values["searchName"],
        domain: values["searchDomain"],
        crCdList: values["crCdList"],
        address: values["searchAddress"],
        perPage: values["perPageSearch"],
        curPage: values["curPageSearch"],
      };

      let fileName = dateFormat(new Date(), "yymmdd") + " WeCrest Contacts";
      // if (values["fromDate"] && values["fromDate"] != '') {
      //   fileName += " ("+ values["fromDate"].replace(/-/gi,"") + "-" + values["toDate"].replace(/-/gi,"") + ")"; 
      // }

      if (submitType == "view") {
        dispatch(onGetContactsList(filterParam));
        const settingsParam = {
          targetGroupName: values["entityName"],
          domain: values["entityWebDomain"],
          entityStatus: values["entityStatus"],
          emailAddress: values["contactEmail"],
          name: values["contactName"],
          title: values["contactTitle"],
          position: values["contactPosition"],
          country: values["contactCountry"],
          office: values["contactOffice"],
          unsubscribe: values["contactStatus"],
          datePeriod: values["datePeriod"],
        };
        // dispatch(onSetSearchSettings(settingsParam));
      } else if (submitType == "Star") {
        const _mainList = [];
        mainList.map((entity, entityIdx) => {
          if (entity.checked && !entity.starred) {
            _mainList.push(entity);
          }
        });

        dispatch(onMultipleStarContacts(_mainList, filterParam, "Manage"));

        setStarOrUnstar("Star");
        setHideOrUnhide("Hide");
      } else if (submitType == "Unstar") {
        const _mainList = [];
        mainList.map((entity, entityIdx) => {
          if (entity.checked && entity.starred) {
            _mainList.push(entity);
          }
        });

        dispatch(onMultipleUnstarContacts(_mainList, filterParam, "Manage"));

        setStarOrUnstar("Star");
        setHideOrUnhide("Hide");
      } else if (submitType == "Hide") {
        const _mainList = [];
        mainList.map((entity, entityIdx) => {
          if (entity.checked && !entity.hidden) {
            _mainList.push(entity);
          }
        });

        dispatch(onMultipleHideContacts(_mainList, filterParam, "Manage"));

        setStarOrUnstar("Star");
        setHideOrUnhide("Hide");
      } else if (submitType == "Unhide") {
        const _mainList = [];
        mainList.map((entity, entityIdx) => {
          if (entity.checked && entity.hidden) {
            _mainList.push(entity);
          }
        });

        dispatch(onMultipleUnhideContacts(_mainList, filterParam, "Manage"));

        setStarOrUnstar("Star");
        setHideOrUnhide("Hide");
      } else if (submitType == "Save" || submitType == "Delete") {
        const _contactsList = [];
        mainList.map((entity, entityIdx) => {
          entity.contactsList.map((contact, contactIdx) => {
            if (contact.checked) _contactsList.push(contact);
          });
        });

        if (submitType == "Save") dispatch(onSaveContacts(_contactsList, filterParam));
        else if (submitType == "Delete") dispatch(onDeleteContacts(_contactsList, filterParam));

      } else if (submitType == "Unsubscribed" || submitType == "Confirmed") {
        let value = submitType == "Unsubscribed" ? "Y" : "N"
        let _mainList = cloneDeep(mainList);
        const _contactsList = [];
        _mainList.map((entity, entityIdx) => {
          entity.contactsList.map((contact, contactIdx) => {
            if (contact.checked) {
              contact.unsubscribe = value;
              _contactsList.push(contact);
            }
          });
        });

        dispatch(onMultipleUnsubscribeContacts(_contactsList, filterParam));
      } else if (submitType.indexOf("Star_") === 0
        || submitType.indexOf("Unstar_") === 0
        || submitType.indexOf("Hide_") === 0
        || submitType.indexOf("Unhide_") === 0) {
        let targetGroupNo = submitType.substring(submitType.lastIndexOf("_") + 1, submitType.length);
        const _mainList = [];
        mainList.map((entity, entityIdx) => {
          if (targetGroupNo == entity.targetGroupNo) {
            _mainList.push(entity);
          }
        });

        if (submitType.indexOf("Star_") === 0) dispatch(onMultipleStarContacts(_mainList, filterParam, "Manage"));
        else if (submitType.indexOf("Unstar_") === 0) dispatch(onMultipleUnstarContacts(_mainList, filterParam, "Manage"));
        else if (submitType.indexOf("Hide_") === 0) dispatch(onMultipleHideContacts(_mainList, filterParam, "Manage"));
        else if (submitType.indexOf("Unhide_") === 0) dispatch(onMultipleUnhideContacts(_mainList, filterParam, "Manage"));

      } else if (submitType.indexOf("Unsubscribed_") === 0
        || submitType.indexOf("Confirmed_") === 0) {
        let targetGroupNo = submitType.substring(submitType.indexOf("_") + 1, submitType.lastIndexOf("_"));
        let emailSeq = submitType.substring(submitType.lastIndexOf("_") + 1, submitType.length);
        let value = submitType.indexOf("Unsubscribed_") === 0 ? "Y" : "N"
        let _contactsList = [];
        mainList.map((entity, entityIdx) => {
          if (targetGroupNo == entity.targetGroupNo) {
            entity.contactsList.map((contact, contactIdx) => {
              if (emailSeq == contact.emailSeq) {
                _contactsList.push(contact);
              }
            });
          }
        });
        _contactsList[0].unsubscribe = value;
        dispatch(onMultipleUnsubscribeContacts(_contactsList, filterParam));
      } else if (submitType == "saveSettings") {
        const settingsParam = {
          targetGroupName: values["entityName"],
          domain: values["entityWebDomain"],
          entityStatus: values["entityStatus"],
          emailAddress: values["contactEmail"],
          name: values["contactName"],
          title: values["contactTitle"],
          position: values["contactPosition"],
          country: values["contactCountry"],
          office: values["contactOffice"],
          unsubscribe: values["contactStatus"],
          datePeriod: values["datePeriod"],
        };

        // console.log(settingsParam);

        dispatch(onSaveContactsSettings(settingsParam));

      } else if (submitType == "excel") {
        dispatch(onDownContactsExcel(filterParam, fileName));
      } else if (submitType == "viewUp") {
        const filterParamUp = {
          emailAddress: values["emailAddress"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          title: values["title"],
          position: values["position"],
          country: values["country"],
          office: values["office"],
          perPage: values["perPageUp"],
          curPage: values["curPageUp"],
          importHisSortType: values['importHisSortType']
        };

        dispatch(onGetUploadedContactsList(filterParamUp));
      } else if (submitType == "saveUp" || submitType == "deleteUp") {
        const filterParamUp = {
          emailAddress: values["emailAddress"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          title: values["title"],
          position: values["position"],
          country: values["country"],
          office: values["office"],
          perPage: values["perPageUp"],
          curPage: values["curPageUp"],
        };

        const _uploadedContactsList = [];
        uploadedContactsList.map((entity, entityIdx) => {
          if (entity.checked) _uploadedContactsList.push(entity);
        });

        if (submitType == "saveUp") dispatch(onSaveUploadedContacts(_uploadedContactsList, filterParamUp));
        else if (submitType == "deleteUp") dispatch(onDeleteUploadedContacts(_uploadedContactsList, filterParamUp));
      } else if (submitType.startsWith("delUpByFile_")) {
        const fileSeq = submitType.split("_").length > 1 ? submitType.split("_")[1] : "-1"
        const filterParamUp = {
          emailAddress: values["emailAddress"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          title: values["title"],
          position: values["position"],
          country: values["country"],
          office: values["office"],
          perPage: values["perPageUp"],
          curPage: values["curPageUp"],
          importHisSortType: values["importHisSortType"]
        };
        dispatch(onDeleteUploadedContactsByFile({ seq: fileSeq }, filterParamUp));
      } else if (submitType == "excelUp") {
        const filterParamUp = {
          emailAddress: values["emailAddress"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          title: values["title"],
          position: values["position"],
          country: values["country"],
          office: values["office"],
        };

        dispatch(onDownUploadedContactsExcel(filterParamUp));
      } else if (submitType == "excelSearch") {
        if (values["entityStatusSearch"] === '' && values["searchName"] === '' && values["searchDomain"] === '') {
          dispatch(onSetContacsResult(9));
        } else if (values["entityStatusSearch"] === 'onlyNonHidden' && values["searchName"] === '' && values["searchDomain"] === '') {
          dispatch(onSetContacsResult(15));
        } else {
          dispatch(downSearchEntityExcel(filterParamSearch, "Search entity " + dateFormat(new Date(), "yymmdd")));
        }
      } else if (submitType == "viewSearch") {

        if (values["entityStatusSearch"] === '' && values["searchName"] === '' && values["searchDomain"] === '') {
          dispatch(onSetContacsResult(9));
        } else if (values["entityStatusSearch"] === 'onlyNonHidden' && values["searchName"] === '' && values["searchDomain"] === '') {
          dispatch(onSetContacsResult(15));
        } else {
          dispatch(onGetContactSearchList(filterParamSearch));
        }
      } else if (submitType == "StarSearch") {
        const _searchList = [];
        searchList.map((entity, entityIdx) => {
          if (entity.checked && !entity.starred) {
            _searchList.push(entity);
          }
        });

        dispatch(onMultipleStarContacts(_searchList, filterParamSearch, "Search"));
        setChkAllFlag_Search(false);
        setStarOrUnstar_Search("Star");
        setHideOrUnhide_Search("Hide");

      } else if (submitType == "UnstarSearch") {
        const _searchList = [];
        searchList.map((entity, entityIdx) => {
          if (entity.checked && entity.starred) {
            _searchList.push(entity);
          }
        });

        dispatch(onMultipleUnstarContacts(_searchList, filterParamSearch, "Search"));
        setChkAllFlag_Search(false);
        setStarOrUnstar_Search("Star");
        setHideOrUnhide_Search("Hide");
      } else if (submitType == "HideSearch") {
        const _searchList = [];
        searchList.map((entity, entityIdx) => {
          if (entity.checked && !entity.hidden) {
            _searchList.push(entity);
          }
        });

        dispatch(onMultipleHideContacts(_searchList, filterParamSearch, "Search"));
        setChkAllFlag_Search(false);
        setStarOrUnstar_Search("Star");
        setHideOrUnhide_Search("Hide");
      } else if (submitType == "UnhideSearch") {
        const _searchList = [];
        searchList.map((entity, entityIdx) => {
          if (entity.checked && entity.hidden) {
            _searchList.push(entity);
          }
        });

        dispatch(onMultipleUnhideContacts(_searchList, filterParamSearch, "Search"));
        setChkAllFlag_Search(false);
        setHideOrUnhide_Search("Hide");
        setStarOrUnstar_Search("Star");
        setHideOrUnhide_Search("Hide");
      } else if (submitType.indexOf("StarSearch_") === 0
        || submitType.indexOf("UnstarSearch_") === 0
        || submitType.indexOf("HideSearch_") === 0
        || submitType.indexOf("UnhideSearch_") === 0) {
        let targetGroupNo = submitType.substring(submitType.lastIndexOf("_") + 1, submitType.length);
        const _searchList = [];
        searchList.map((entity, entityIdx) => {
          if (targetGroupNo == entity.targetGroupNo) {
            _searchList.push(entity);
          }
        });

        if (submitType.indexOf("StarSearch_") === 0) dispatch(onMultipleStarContacts(_searchList, filterParamSearch, "Search"));
        else if (submitType.indexOf("UnstarSearch_") === 0) dispatch(onMultipleUnstarContacts(_searchList, filterParamSearch, "Search"));
        else if (submitType.indexOf("HideSearch_") === 0) dispatch(onMultipleHideContacts(_searchList, filterParamSearch, "Search"));
        else if (submitType.indexOf("UnhideSearch_") === 0) dispatch(onMultipleUnhideContacts(_searchList, filterParamSearch, "Search"));
      } else if (submitType == "Disable") {
        const _contactsList = [];
        mainList.map((entity, entityIdx) => {
          entity.contactsList.map((contact, contactIdx) => {
            if (contact.checked && contact.unsubscribe !== "Y" && contact.unsubscribe !== "D") _contactsList.push(contact);
          });
        });
        dispatch(disableContactSendYn(_contactsList, filterParam));
      } else if (submitType == "Enable") {
        const _contactsList = [];
        mainList.map((entity, entityIdx) => {
          entity.contactsList.map((contact, contactIdx) => {
            if (contact.checked && contact.unsubscribe !== "Y" && contact.unsubscribe !== "D") _contactsList.push(contact);
          });
        });
        dispatch(enableContactSendYn(_contactsList, filterParam));
      }

    },
  });

  const viewContactsList = (sortType, curPage, perPage) => {
    //curPage 유효성 체크
    if (curPage) {
      if (curPage > totalPage) {
        curPage = totalPage;
      } else if (curPage <= 0) {
        curPage = 1;
      }
    }

    // console.log("viewContactsList [sortType: "+sortType+", curPage: "+curPage+", perPage: "+perPage);
    let _values = cloneDeep(filterValidation.values);
    _values.submitType = "view";
    if (sortType) {
      _values.sortType = sortType;
    }
    if (curPage) {
      _values.curPage = curPage;
      setCurPageInput(curPage);
    } else {
      _values.curPage = 1;
      setCurPageInput(1);
    }
    if (perPage) {
      _values.perPage = perPage;
    }
    filterValidation.setValues(_values);
    filterValidation.handleSubmit(filterValidation.values);
  }

  const [lastEntityCheckedIdx, setLastEntityCheckedIdx] = useState(-1);
  const entityCheck = (entityChkIdx, e) => {
    let _mainList = cloneDeep(mainList);
    let starredCnt = 0;
    let hiddenCnt = 0;
    let disabledCnt = 0;
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    if (entityChkIdx == "chkAll") {
      setChkAllFlag(value);
      setLastEntityCheckedIdx(-1)
      _mainList = _mainList.map((entity, entityIdx) => {
        entity.checked = value;
        let disabledContacrsCnt = 0;
        entity.contactsList.map((contact, contactIdx) => {
          contact.checked = value;
          if (contact.sendYn === 'N' && contact.hagueSendYn === 'N' && contact.filerSendYn === 'N' && contact.pctSendYn === 'N') {
            disabledContacrsCnt++;
          }
          return contact;
        })

        if (disabledContacrsCnt === entity.contactsList.length) {
          disabledCnt++;
        }

        if (entity.starred) starredCnt++;
        if (entity.hidden) hiddenCnt++;

        return entity;
      })

      if (starredCnt === mainList.length) {
        setStarOrUnstar("Unstar");
      } else {
        setStarOrUnstar("Star");
      }

      if (hiddenCnt === mainList.length) {
        setHideOrUnhide("Unhide");
      } else {
        setHideOrUnhide("Hide");
      }

      if (disabledCnt === mainList.length) {
        setEnableOrDisable("Enable");
      } else {
        setEnableOrDisable("Disable");
      }

    } else {
      let entityChkCnt = 0;

      _mainList = _mainList.map((entity, entityIdx) => {
        let disabledContacrsCnt = 0;
        if (shift && ctrlOrCmd && lastEntityCheckedIdx != -1) {
          const start = Math.min(entityChkIdx, lastEntityCheckedIdx);
          const end = Math.max(entityChkIdx, lastEntityCheckedIdx);
          if (entityIdx >= start && entityIdx <= end) {
            entity.checked = value;
            entity.contactsList.map((contact, contactIdx) => {
              if (contact.sendYn === 'N' && contact.hagueSendYn === 'N' && contact.filerSendYn === 'N' && contact.pctSendYn === 'N') {
                disabledContacrsCnt++;
              }
              contact.checked = value;

              return contact;
            })
          }
        } else if (entityChkIdx == entityIdx) {
          entity.checked = value;
          entity.contactsList.map((contact, contactIdx) => {
            if (contact.sendYn === 'N' && contact.hagueSendYn === 'N' && contact.filerSendYn === 'N' && contact.pctSendYn === 'N') {
              disabledContacrsCnt++;
            }
            contact.checked = value;

            return contact;
          })
        }

        if (entity.checked) {
          entityChkCnt++;
          if (entity.starred) starredCnt++;
          if (entity.hidden) hiddenCnt++;
          if (disabledContacrsCnt === entity.contactsList.length) {
            disabledCnt++;
          }
        }

        return entity;
      })

      if (entityChkCnt === mainList.length) {
        setChkAllFlag(true);
      } else {
        setChkAllFlag(false);
      }

      if (starredCnt === entityChkCnt && entityChkCnt !== 0) {
        setStarOrUnstar("Unstar");
      } else {
        setStarOrUnstar("Star");
      }

      if (hiddenCnt === entityChkCnt && entityChkCnt !== 0) {
        setHideOrUnhide("Unhide");
      } else {
        setHideOrUnhide("Hide");
      }

      if (disabledCnt === entityChkCnt && entityChkCnt !== 0) {
        setEnableOrDisable("Enable");
      } else {
        setEnableOrDisable("Disable");
      }
      setLastEntityCheckedIdx(entityChkIdx)
    }

    dispatch(onChangeContactsList(_mainList));
  }

  const [lastContactCheckedIdx, setLastContactCheckedIdx] = useState(-1);
  const [lastContactCheckedEntityIdx, setLastContactCheckedEntityIdx] = useState(-1);
  const contactCheck = (entityChkIdx, contactChkIdx, e) => {
    let _mainList = cloneDeep(mainList);
    let entityChkCnt = 0;
    let contactChkCnt = 0;
    let starredCnt = 0;
    let hiddenCnt = 0;
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    _mainList = _mainList.map((entity, entityIdx) => {
      if (entityChkIdx == entityIdx) {
        entity.contactsList.map((contact, contactIdx) => {
          if (entityIdx === lastContactCheckedEntityIdx && shift && ctrlOrCmd && lastContactCheckedIdx != -1) {
            const start = Math.min(contactChkIdx, lastContactCheckedIdx);
            const end = Math.max(contactChkIdx, lastContactCheckedIdx);
            if (contactIdx >= start && contactIdx <= end) {
              contact.checked = value;
            }
          }
          else if (contactChkIdx == contactIdx) {
            contact.checked = value;
          }
          if (contact.checked == true) {
            contactChkCnt++;
          }
          return contact;
        })

        if (contactChkCnt == entity.contactsList.length) {
          entity.checked = true;
        } else {
          entity.checked = false;
        }
      }
      if (entity.checked == true) {
        entityChkCnt++;
        if (entity.starred) starredCnt++;
        if (entity.hidden) hiddenCnt++;
      }
      return entity;
    })

    setLastContactCheckedIdx(contactChkIdx)
    setLastContactCheckedEntityIdx(entityChkIdx)

    if (entityChkCnt === mainList.length) {
      setChkAllFlag(true);
    } else {
      setChkAllFlag(false);
    }

    if (starredCnt === entityChkCnt && entityChkCnt !== 0) {
      setStarOrUnstar("Unstar");
    } else {
      setStarOrUnstar("Star");
    }

    if (hiddenCnt === entityChkCnt && entityChkCnt !== 0) {
      setHideOrUnhide("Unhide");
    } else {
      setHideOrUnhide("Hide");
    }

    dispatch(onChangeContactsList(_mainList));
  }

  const handleTypeSelect = (entityIdx, contactIdx, value) => {
    let _mainList = cloneDeep(mainList);
    _mainList[entityIdx].contactsList[contactIdx].type = value;

    dispatch(onChangeContactsList(_mainList));
  }

  const handleInput = (attr, entityIdx, contactIdx, value) => {
    let _mainList = cloneDeep(mainList);
    _mainList[entityIdx].contactsList[contactIdx][attr] = value;

    dispatch(onChangeContactsList(_mainList));
  }

  const addContacts = (targetGroupNo, entityIdx) => {
    let _mainList = cloneDeep(mainList);
    let newRow = { "targetGroupNo": targetGroupNo, "emailSeq": null, "emailAddress": null, "modFlag": "I", "type": "To", "firstName": null, "lastName": null, "title": null, "position": null, "unsubscribe": "N", "checked": true, "sendYn": "Y", "hagueSendYn": "Y", "filerSendYn": "Y", "pctSendYn": "Y" };
    _mainList[entityIdx].contactsList.push(newRow);

    dispatch(onChangeContactsList(_mainList));
  }

  const checkContactListLimit = (existingList) => {
    let validMNNCount = 0
    let validHNCount = 0
    let validFRCount = 0
    let validPCTCount = 0

    const countContactsByType = (contactList) => {
      contactList.forEach((contact) => {
        if (contact.unsubscribe !== 'Y' && contact.emailAddress && contact.emailAddress !== '') {
          if (contact.sendYn === 'Y') validMNNCount++;
          if (contact.hagueSendYn === 'Y') validHNCount++;
          if (contact.filerSendYn === 'Y') validFRCount++;
          if (contact.pctSendYn === 'Y') validPCTCount++;
        }
      });
    };

    countContactsByType(existingList);

    if (validMNNCount > 3 || validHNCount > 3 || validFRCount > 3 || validPCTCount > 3) {
      return false;
    } else {
      return true;
    }
  }

  const entityChk = () => {
    let chkCnt = 0;
    mainList.map((entity, entityIdx) => {
      if (entity.checked === true) chkCnt++;
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(1));
      return false;
    }

    return true;
  }

  const contactChk = () => {
    let chkCnt = 0;
    let notSaveCnt = 0;
    mainList.map((entity, entityIdx) => {
      entity.contactsList.map((contact, contactIdx) => {
        if (contact.checked === true) {
          chkCnt++;
          if (contact.modFlag == "I") notSaveCnt++;
        }
      })
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(2));
      return false;
    }
    if (notSaveCnt > 0) {
      dispatch(onSetContacsResult(3));
      return false;
    }

    return true;
  }

  useEffect(() => {
    setLastEntityCheckedIdx(-1);
    setLastEntityUpCheckedIdx(-1);
    setLastEntityCheckedSearchIdx(-1);
    setLastContactCheckedIdx(-1);
    setLastContactCheckedEntityIdx(-1);
  }, [filterValidation.values.submitType])

  const saveValidation = () => {
    let chkCnt = 0;
    let noEmail = false;
    let noFirstName = false;
    let invalidEmail = false;
    let regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,15}$/i;
    let checkUnsubsEmail = [];
    let checkDupeEmailAddress = [];
    let checkContactListLimitFlagCount = 0;

    mainList.map((entity, entityIdx) => {
      entity.contactsList.map((contact, contactIdx) => {
        if (contact.checked === true) {
          chkCnt++;
          if (!contact.emailAddress) {
            noEmail = true;
          } else {
            if (contact.emailAddress.match(regex) == null) invalidEmail = true;
          }

          // if (contact.modFlag === "I") {
          checkUnsubsEmail.push(contact);
          // }

          // if(!contact.firstName){
          //   noFirstName = true;
          // }

          mainList.map((entity2, entityIdx2) => {
            entity2.contactsList.map((contact2, contactIdx2) => {
              if (entityIdx == entityIdx2 && contactIdx != contactIdx2 && contact.emailAddress && contact.emailAddress != '' && contact.emailAddress.toLowerCase() == contact2.emailAddress.toLowerCase() && !checkDupeEmailAddress.includes(contact.emailAddress)) {
                checkDupeEmailAddress.push(contact.emailAddress)
              }
            })
          })
        }
      })
    });

    if (checkDupeEmailAddress.length > 0) {
      setDupeEmailAddress(checkDupeEmailAddress);
      dispatch(onSetContacsResult(7));
      return false;
    }

    // Check contact limits only for entities being saved
    let entitiesBeingSaved = new Set();
    mainList.map((entity, entityIdx) => {
      entity.contactsList.map((contact, contactIdx) => {
        if (contact.checked === true) {
          entitiesBeingSaved.add(entityIdx);
        }
      })
    });

    entitiesBeingSaved.forEach(entityIdx => {
      if (checkContactListLimit(mainList[entityIdx].contactsList) === false) {
        checkContactListLimitFlagCount++;
      }
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(2));
      return false;
    } else if (noEmail) {
      dispatch(onSetContacsResult(4));
      return false;
    } else if (invalidEmail) {
      dispatch(onSetContacsResult(5));
      return false;
    } else if (noFirstName) {
      dispatch(onSetContacsResult(6));
      return false;
    } else if (checkContactListLimitFlagCount > 0) {
      dispatch(onSetContacsResult(10));
      return false;
    } else {
      if (checkUnsubsEmail.length > 0) {
        // console.log('checkUnsubsEmail : ' + JSON.stringify(checkUnsubsEmail))
        dispatch(onCheckEmailUnsubscribe(checkUnsubsEmail, '', 'List'));
        return false;
      } else {
        return true;
      }
    }
  }

  const setContactsLoading = (type) => {
    dispatch(onSetContactsLoading(type));
  }

  const [modalContactsScreen, setModalContactsScreen] = useState(false);
  const [contactsTargetGroupNo, setContactsTargetGroupNo] = useState(0);
  function togContactsScreen(targetGroupNo) {
    if (targetGroupNo) {
      setContactsTargetGroupNo(targetGroupNo);
    } else {
      setContactsTargetGroupNo(0);
      if (activeTab === 'Manage') {
        filterValidation.setFieldValue("submitType", "view");
      } else if (activeTab === 'Search') {
        filterValidation.setFieldValue("submitType", "viewSearch");
      }

      filterValidation.handleSubmit(filterValidation.values);
    }
    setModalContactsScreen(!modalContactsScreen);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
    document.body.classList.add("modal-open")
  }

  const [lastEntityUpCheckedIdx, setLastEntityUpCheckedIdx] = useState(-1);
  const entityCheckUp = (entityChkIdx, e) => {
    let _uploadedContactsList = cloneDeep(uploadedContactsList);
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    if (entityChkIdx == "chkAll") {
      setChkAllFlagUp(value);
      _uploadedContactsList = _uploadedContactsList.map((entity, entityIdx) => {
        entity.checked = value;

        return entity;
      })
      setLastEntityUpCheckedIdx(-1)

    } else {
      let entityChkCnt = 0;

      _uploadedContactsList = _uploadedContactsList.map((entity, entityIdx) => {
        if (shift && ctrlOrCmd && lastEntityUpCheckedIdx != -1) {
          const start = Math.min(entityChkIdx, lastEntityUpCheckedIdx);
          const end = Math.max(entityChkIdx, lastEntityUpCheckedIdx);
          if (entityIdx >= start && entityIdx <= end) {
            entity.checked = value;
          }
        } else if (entityChkIdx == entityIdx) {
          entity.checked = value;
        }
        if (entity.checked) {
          entityChkCnt++;
        }

        return entity;
      })

      if (entityChkCnt === uploadedContactsList.length) {
        setChkAllFlagUp(true);
      } else {
        setChkAllFlagUp(false);
      }
      setLastEntityUpCheckedIdx(entityChkIdx)
    }

    dispatch(onChangeUploadedContactsList(_uploadedContactsList));
  }

  const handleInputUp = (attr, entityIdx, value) => {
    // console.log(attr, entityIdx, value);
    let _uploadedContactsList = cloneDeep(uploadedContactsList);
    _uploadedContactsList[entityIdx][attr] = value;

    dispatch(onChangeUploadedContactsList(_uploadedContactsList));
  }

  const viewContactsListUp = (curPageUp, perPageUp) => {
    // console.log("viewContactsListUp 1 [curPageUp: "+curPageUp+", perPageUp: "+perPageUp);

    //curPage 유효성 체크
    if (curPageUp) {
      if (curPageUp > totalPageUp) {
        curPageUp = totalPageUp;
      } else if (curPageUp <= 0) {
        curPageUp = 1;
      }
    }

    // console.log("viewContactsListUp 2 [curPageUp: "+curPageUp+", perPageUp: "+perPageUp);
    let _values = cloneDeep(filterValidation.values);
    _values.submitType = "viewUp";

    if (curPageUp) {
      _values.curPageUp = curPageUp;
      setCurPageInputUp(curPageUp);
    } else {
      _values.curPageUp = 1;
      setCurPageInputUp(1);
    }
    if (perPageUp) {
      _values.perPageUp = perPageUp;
    }
    filterValidation.setValues(_values);
    filterValidation.handleSubmit(filterValidation.values);
  }

  const contactChkUp = () => {
    let chkCnt = 0;
    uploadedContactsList.map((contact, entityIdx) => {
      if (contact.checked === true) {
        chkCnt++;
      }
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(2));
      return false;
    }

    return true;
  }

  const saveValidationUp = () => {
    let chkCnt = 0;
    let noEmail = false;
    let noFirstName = false;
    let invalidEmail = false;
    let regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,15}$/i;

    uploadedContactsList.map((contact, entityIdx) => {
      if (contact.checked === true) {
        chkCnt++;
        if (!contact.emailAddress) {
          noEmail = true;
        } else {
          if (contact.emailAddress.match(regex) == null) invalidEmail = true;
        }

        // if(!contact.firstName){
        //   noFirstName = true;
        // }
      }
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(2));
      return false;
    } else if (noEmail) {
      dispatch(onSetContacsResult(4));
      return false;
    } else if (invalidEmail) {
      dispatch(onSetContacsResult(5));
      return false;
    } else if (noFirstName) {
      dispatch(onSetContacsResult(6));
      return false;
    } else {
      return true;
    }
  }

  function showSuccessCopyToast() {
    const ele = "success";
    const position = "toast-bottom-left"
    const title = ""
    let message = "Copy clipboard!"

    //Close Button
    const closeButton = false

    //Debug
    const debug = false

    //Progressbar
    const progressBar = false

    //Duplicates
    const preventDuplicates = false

    //Newest on Top
    const newestOnTop = false

    //position class
    let positionClass = "toast-bottom-left"

    //Show Easing
    const showEasing = "swing";

    //Hide Easing
    const hideEasing = "linear";

    //show method
    const showMethod = "fadeIn";

    //Hide method
    const hideMethod = "fadeOut";

    //show duration
    const showDuration = 300;

    //Hide duration
    const hideDuration = 1000;

    //timeout
    const timeOut = 1000;

    //extended timeout
    const extendedTimeOut = 1000;

    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      debug: debug,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showEasing: showEasing,
      hideEasing: hideEasing,
      showMethod: showMethod,
      hideMethod: hideMethod,
      showDuration: showDuration,
      hideDuration: hideDuration
    }

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    toastr.success(message, title)
  }

  const unsecuredCopyToClipboard = (text, elmentId) => {
    const textArea = document.createElement("textarea");
    textArea.setAttribute("type", "hidden");
    textArea.value = text;

    // const node = document.getElementById(elmentId).lastElementChild;
    document.getElementById(elmentId).appendChild(textArea);
    // document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.getElementById(elmentId).removeChild(textArea);
  }

  const viewContactsSearchList = (sortType, curPageSearch, perPageSearch) => {
    //curPage 유효성 체크
    if (curPageSearch) {
      if (curPageSearch > totalPageSearch) {
        curPageSearch = totalPageSearch;
      } else if (curPageSearch <= 0) {
        curPageSearch = 1;
      }
    }

    // console.log("viewContactsList [sortType: "+sortType+", curPage: "+curPage+", perPage: "+perPage);
    let _values = cloneDeep(filterValidation.values);
    _values.submitType = "viewSearch";
    if (sortType) {
      _values.sortType = sortType;
    }
    if (curPageSearch) {
      _values.curPageSearch = curPageSearch;
      setCurPageSearch(curPageSearch);
    } else {
      _values.curPageSearch = 1;
      setCurPageSearch(1);
    }
    if (perPageSearch) {
      _values.perPageSearch = perPageSearch;
    }
    filterValidation.setValues(_values);
    filterValidation.handleSubmit(filterValidation.values);
  }

  const [lastEntityCheckedSearchIdx, setLastEntityCheckedSearchIdx] = useState(-1);
  const entityCheckSearch = (entityChkIdx, e) => {
    let _searchList = cloneDeep(searchList);
    let starredCnt = 0;
    let hiddenCnt = 0;
    const value = e.target.checked;
    const shift = e.shiftKey;
    const ctrlOrCmd = e.ctrlKey || e.metaKey;

    if (entityChkIdx == "chkAll") {
      setLastEntityCheckedSearchIdx(-1)
      setChkAllFlag_Search(value);
      _searchList = _searchList.map((entity, entityIdx) => {
        entity.checked = value;

        if (entity.starred) starredCnt++;
        if (entity.hidden) hiddenCnt++;

        return entity;
      })

      if (starredCnt === searchList.length) {
        setStarOrUnstar_Search("Unstar");
      } else {
        setStarOrUnstar_Search("Star");
      }

      if (hiddenCnt === searchList.length) {
        setHideOrUnhide_Search("Unhide");
      } else {
        setHideOrUnhide_Search("Hide");
      }

    } else {
      let entityChkCnt = 0;

      _searchList = _searchList.map((entity, entityIdx) => {
        if (shift && ctrlOrCmd && lastEntityCheckedSearchIdx != -1) {
          const start = Math.min(entityChkIdx, lastEntityCheckedSearchIdx);
          const end = Math.max(entityChkIdx, lastEntityCheckedSearchIdx);
          if (entityIdx >= start && entityIdx <= end) {
            entity.checked = value;
          }
        } else if (entityChkIdx == entityIdx) {
          entity.checked = value;
        }
        if (entity.checked) {
          entityChkCnt++;
          if (entity.starred) starredCnt++;
          if (entity.hidden) hiddenCnt++;
        }

        return entity;
      })

      if (entityChkCnt === searchList.length) {
        setChkAllFlag_Search(true);
      } else {
        setChkAllFlag_Search(false);
      }

      if (starredCnt === entityChkCnt && entityChkCnt !== 0) {
        setStarOrUnstar_Search("Unstar");
      } else {
        setStarOrUnstar_Search("Star");
      }

      if (hiddenCnt === entityChkCnt && entityChkCnt !== 0) {
        setHideOrUnhide_Search("Unhide");
      } else {
        setHideOrUnhide_Search("Hide");
      }
      setLastEntityCheckedSearchIdx(entityChkIdx);
    }

    dispatch(onChangeContactSearchList(_searchList));
  }

  const entityChkSearch = () => {
    let chkCnt = 0;
    searchList.map((entity, entityIdx) => {
      if (entity.checked === true) chkCnt++;
    });

    if (chkCnt === 0) {
      dispatch(onSetContacsResult(1));
      return false;
    }

    return true;
  }

  useEffect(() => {
    dispatch(onGetAllCountryList());
  }, []);
  // console.log({contactSearchLoading, loading})

  return (
    <React.Fragment>
      <Form onSubmit={filterValidation.handleSubmit}>
        <div className="page-content">
          <div className="container-fluid">
            <Nav tabs className="col-md-7 nav-tabs-custom nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: activeTab === "Manage",
                  })}
                  onClick={() => {
                    toggleActiveTab("Manage")
                  }}
                >
                  <span>Manage Contacts</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: activeTab === "Upload",
                  })}
                  onClick={() => {
                    toggleActiveTab("Upload");
                  }}
                >
                  <span>Imported Email Addresses</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: activeTab === "Search",
                  })}
                  onClick={() => {
                    toggleActiveTab("Search")
                  }}
                >
                  <span>Search entity</span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={activeTab}
              className="text-muted"
            >
                  <ManageContacts
                    activeTab={activeTab}
                    filterValidation={filterValidation}
                    countryList={countryList}
                    noticeStr={noticeStr}
                    mainList={mainList}
                    userGrade={userGrade}
                    starOrUnstar={starOrUnstar}
                    hideOrUnhide={hideOrUnhide}
                    curPageInput={curPageInput}
                    chkAllFlag={chkAllFlag}
                    totalPage={totalPage}
                    enableOrDisable={enableOrDisable}
                    setCurPageInput={setCurPageInput}
                    entityChk={entityChk}
                    entityCheck={entityCheck}
                    setConfirmMsg={setConfirmMsg}
                    setConfirmAlert={setConfirmAlert}
                    saveValidation={saveValidation}
                    contactChk={contactChk}
                    contactCheck={contactCheck}
                    togContactsScreen={togContactsScreen}
                    unsecuredCopyToClipboard={unsecuredCopyToClipboard}
                    showSuccessCopyToast={showSuccessCopyToast}
                    handleInput={handleInput}
                    addContacts={addContacts}
                    viewContactsList={viewContactsList}
                    toggle={toggle}
                    isOpen={isOpen}
                  />

                  <UploadedContacts
                    activeTab={activeTab}
                    filterValidation={filterValidation}
                    countryList={countryList}
                    uploadContactsHistory={uploadContactsHistory}
                    noticeStrUp={noticeStrUp}
                    uploadedContactsList={uploadedContactsList}
                    isOpen={isOpen}
                    setConfirmMsg={setConfirmMsg}
                    setConfirmAlert={setConfirmAlert}
                    toggle={toggle}
                    setCurPageInputUp={setCurPageInputUp}
                    saveValidationUp={saveValidationUp}
                    contactChkUp={contactChkUp}
                    entityCheckUp={entityCheckUp}
                    handleInputUp={handleInputUp}
                    viewContactsListUp={viewContactsListUp}
                    onSetUploadContactsOpen={onSetUploadContactsOpen}
                    chkAllFlagUp={chkAllFlagUp}
                    totalPageUp={totalPageUp}
                    curPageInputUp={curPageInputUp}
                  />

                  <SearchEntity
                    isOpen={isOpen}
                    filterValidation={filterValidation}
                    searchList={searchList}
                    toggle={toggle}
                    starOrUnstar_Search={starOrUnstar_Search}
                    hideOrUnhide_Search={hideOrUnhide_Search}
                    chkAllFlag_Search={chkAllFlag_Search}
                    totalPageSearch={totalPageSearch}
                    curPageSearch={curPageSearch}
                    togContactsScreen={togContactsScreen}
                    unsecuredCopyToClipboard={unsecuredCopyToClipboard}
                    setCurPageSearch={setCurPageSearch}
                    entityChkSearch={entityChkSearch}
                    setConfirmMsg={setConfirmMsg}
                    setConfirmAlert={setConfirmAlert}
                    entityCheckSearch={entityCheckSearch}
                    showSuccessCopyToast={showSuccessCopyToast}
                    viewContactsSearchList={viewContactsSearchList}
                  />
            </TabContent>

            <UploadContactsModal />

            {
              loading ?
                <LoadingModal loading={loading} setLoading={() => setContactsLoading('LOADING')}></LoadingModal>
                : null
            }
            {
              contactSearchLoading ?
                <LoadingModal loading={contactSearchLoading} setLoading={() => setContactsLoading('SEARCH_LOADING')}></LoadingModal>
                : null
            }

            <Modal
              size="xl"
              style={{ maxWidth: "1700px" }}
              isOpen={modalContactsScreen}
              toggle={() => {
                togContactsScreen()
              }}
            >
              <div className="modal-body">
                <button
                  onClick={() => {
                    togContactsScreen()
                  }}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>

                <ContactsDetails targetGroupNo={contactsTargetGroupNo} />
              </div>
            </Modal>

            {success ? (
              <SweetAlert
                title={success}
                timeout={2000}
                showCloseButton={false}
                showConfirm={false}
                success
                onConfirm={() => {
                  dispatch(onSetSuccess(""));
                }}
              ></SweetAlert>
            ) : null}

            {(result > -1 && result < 11) || result >= 15 ? (
              <SweetAlert
                onConfirm={() => {
                  dispatch(onSetContacsResult(-1));
                  setDupeEmailAddress([]);
                }}
              >
                {
                  result < 7 ?
                    errMsg[result] :
                    <>
                      {errMsg[result]}
                      <br />
                      {
                        result == 7 ?
                          "[" + dupeEmailAddress + "]" :
                          result == 8 ? unsubsEmailAddress1 :
                            result == 16 ? unsubsEmailAddress2 : ""
                      }
                    </>
                }
              </SweetAlert>
            ) : null}

            {result > 10 & result < 15 ? (
              <SweetAlert
                title={errMsg[result]}
                onConfirm={() => {
                  dispatch(onSetContacsResult(-1));
                  setDupeEmailAddress([]);
                }}
              >
              </SweetAlert>
            ) : null}

            {confirmAlert ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnText="Confirm"
                cancelBtnText="No, go back"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  filterValidation.handleSubmit(filterValidation.values);
                  setConfirmAlert(false);
                }}
                onCancel={() => setConfirmAlert(false)}
              >
                {confirmMsg}
              </SweetAlert>
            ) : null}
          </div>
        </div>
      </Form>
    </React.Fragment>
  )
}

export default Contacts;